import styled from "styled-components";
import {LiveCasinoFilterButtonLabelDefaultBox} from "./live-casino-filter-button-label.default.box";

export const LiveCasinoFilterButtonLabelCasino777Box = styled(LiveCasinoFilterButtonLabelDefaultBox)`
    font-size: 1.6em;
`;
